import { createSignal, onMount, onCleanup } from "solid-js";
import p5 from "p5";

const Recording = () => {
  const [containerRef, setContainerRef] = createSignal(null);
  let sketch = null;

  onMount(() => {
    if (containerRef()) {
      // Create new p5 instance
      sketch = new p5((p) => {
        let radius = 13;
        const minRadius = 13;
        const maxRadius = 14.5;
        const duration = 1300; // 1 second interval

        p.setup = () => {
          // Create canvas with transparent background
          p.createCanvas(34, 34);
          p.frameRate(30);
        };

        p.draw = () => {
          // Clear background for transparency
          p.clear();

          // Calculate radius based on sin wave
          const phase = (p.millis() % duration) / duration;
          radius =
            minRadius +
            (maxRadius - minRadius) *
              (Math.sin(phase * Math.PI * 2) * 0.5 + 0.5);

          // Draw circle in center of canvas
          p.strokeWeight(1.5);
          p.stroke(255);
          p.fill("#242424");
          p.circle(p.width / 2, p.height / 2, radius * 2);
        };
      }, containerRef());
    }
  });

  onCleanup(() => {
    // Clean up p5 instance when component unmounts
    if (sketch) {
      sketch.remove();
    }
  });

  return (
    <div
      ref={setContainerRef}
      style={{
        margin: 0,
        padding: 0,
        "padding-left": "6px",
        "padding-bottom": "5px",
      }}
    />
  );
};

export default Recording;
